import * as React from 'react';
import { memo } from 'react';

export type RibbonPropsType = {
	text?: string;
};

const Ribbon = ({ text }: RibbonPropsType) => (
	<div className="a-ribbon">{text && <p className="a-ribbon__text">{text}</p>}</div>
);

Ribbon.displayName = 'Ribbon';

export default memo(Ribbon);
